module.exports = __webpack_public_path__ + "img/home-index-menu2.27df56c7.png";